<template>
  <div>
    <TheTopProgressBar
      :ratio="progressRatio"
      :number-of-dots="3"
    />
    <TheHeader
      :back-route="backRoute"
      with-cross
      @close="close"
    />
    <BaseSection>
      <BaseTitleGroup
        :title="title"
        :subtitle="subtitle"
        :small="true"
        :class="{'mb-4': !subSubtitle}"
      >
        {{ title }}
      </BaseTitleGroup>
      <BaseParagraph
        v-if="subSubtitle"
        class="mb-4"
      >
        {{ subSubtitle }}
      </BaseParagraph>
    </BaseSection>
    <form @submit.prevent="$emit('next')">
      <slot />
      <BaseSection>
        <KycButtons
          :theme="nextButtonTheme"
          :alternate-title="alternateTitle"
        />
      </BaseSection>
    </form>
  </div>
</template>

<script>
import kyc from '../../mixins/kyc';
import TheHeader from '../../components/TheHeader.vue';
import KycButtons from '../partials/KycButtons.vue';
import BaseSection from '../../components/BaseSection.vue';
import BaseTitleGroup from '../../components/BaseTitleGroup.vue';
import TheTopProgressBar from '../../components/TheTopProgressBar.vue';
import BaseParagraph from '../../components/BaseParagraph.vue';

export default {
  name: 'Question',
  components: {
    TheHeader,
    KycButtons,
    BaseSection,
    BaseTitleGroup,
    TheTopProgressBar,
    BaseParagraph,
  },
  mixins: [kyc],
  props: {
    backRoute: {
      type: String,
      required: true,
    },
    nextButtonTheme: {
      type: String,
      default: 'primary',
    },
    alternateTitle: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
    subSubtitle: {
      type: String,
      default: null,
    },
    progressRatio: {
      type: Number,
      required: true,
    },
  },
};
</script>
